/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A function resource
 */
export type FunctionResourceDefinition = {
  /**
   * The creation date of the resource.
   */
  createdAt: Date;
  /**
   * The ID of the deployment
   */
  deploymentId: string;
  /**
   * Description of the resource
   */
  description: string;
  /**
   * The ID of the function
   */
  functionId: string;
  /**
   * The ID of the resource
   */
  id: string;
  /**
   * Meta tags for the tool
   */
  meta?: { [k: string]: any } | undefined;
  /**
   * Optional MIME type of the resource
   */
  mimeType?: string | undefined;
  /**
   * The name of the resource
   */
  name: string;
  /**
   * The ID of the project
   */
  projectId: string;
  /**
   * The URN of this resource
   */
  resourceUrn: string;
  /**
   * Runtime environment (e.g., nodejs:24, python:3.12)
   */
  runtime: string;
  /**
   * Optional title for the resource
   */
  title?: string | undefined;
  /**
   * The last update date of the resource.
   */
  updatedAt: Date;
  /**
   * The URI of the resource
   */
  uri: string;
  /**
   * Variables configuration for the resource
   */
  variables?: any | undefined;
};

/** @internal */
export const FunctionResourceDefinition$inboundSchema: z.ZodMiniType<
  FunctionResourceDefinition,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    deployment_id: z.string(),
    description: z.string(),
    function_id: z.string(),
    id: z.string(),
    meta: z.optional(z.record(z.string(), z.any())),
    mime_type: z.optional(z.string()),
    name: z.string(),
    project_id: z.string(),
    resource_urn: z.string(),
    runtime: z.string(),
    title: z.optional(z.string()),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    uri: z.string(),
    variables: z.optional(z.any()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "deployment_id": "deploymentId",
      "function_id": "functionId",
      "mime_type": "mimeType",
      "project_id": "projectId",
      "resource_urn": "resourceUrn",
      "updated_at": "updatedAt",
    });
  }),
);

export function functionResourceDefinitionFromJSON(
  jsonString: string,
): SafeParseResult<FunctionResourceDefinition, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => FunctionResourceDefinition$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'FunctionResourceDefinition' from JSON`,
  );
}
